/* global VGSShow */
import { useContext, useEffect, useRef, useState } from 'react';
import { Box } from '@mui/system';

import SnackBarComponent from 'components/shared/SnackBarComponent';
import { CardContext } from 'context/cards/cardContext';
import { REMOVE_FRAME, SHOW_CARD_INFO } from 'context/cards/types';
import Background from 'assets/cardsSection/cardBackgroud.svg';
import copyIcon from './copyIcon.png';
import './PaystandCard.css';

let screenSize = window.screen.width;
let textSize = '12px';
let letterSpacing = '2.5px';
if (screenSize < 600) {
    textSize = '8px';
    letterSpacing = '1.5px';
}

const secretsTextStyles = {
    '@font-face': {
        'font-family': 'Montserrat',
        src: "url(https://fonts.gstatic.com/s/montserrat/v23/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Hw5aXx-p7K4KLg.woff) format('woff')",
        'unicode-range':
            'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
    },
    'font-family': 'Montserrat',
    'font-size': textSize,
    'line-height': '12px',
    'letter-spacing': letterSpacing,
    color: '#182d55'
    // display: "block"
};
const secretCardNumberStyles = {
    ...secretsTextStyles,
    'line-height': '18px'
};
const copyButtonStyles = {
    '@font-face': {
        'font-family': 'Montserrat',
        src: "url(https://fonts.gstatic.com/s/montserrat/v23/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Hw5aXx-p7K4KLg.woff) format('woff')"
    },
    'font-family': 'Montserrat',
    'font-size': '12px',
    cursor: 'pointer',
    'border-radius': '5px',
    height: '20px',
    width: '20px',
    padding: '5px',
    // top: '0px',
    // right: '0px',
    color: 'white',
    // background: `blue`
    background: `url(${copyIcon}) no-repeat center`
};

function addVgsScript(callback) {
    var vgsScript = document.createElement('script');
    vgsScript.id = 'vgs-script';
    vgsScript.src = 'https://js.verygoodvault.com/vgs-show/1.3/ACci3u9aEmutHr7zpAeVY2Zc.js';
    vgsScript.type = 'text/javascript';
    if (callback) vgsScript.onload = callback;
    document.head.append(vgsScript);
}

const PaystandCard = props => {
    const { card, name, provider, checked } = props;
    const { dispatch, deleteFrame } = useContext(CardContext);
    const [showCardInfo, setShowCardInfo] = useState(false);

    const cardNumberRef = useRef();
    const cvvRef = useRef();
    const SnackBarRef = useRef();

    const showCardSecrets = () => {
        const show = VGSShow.create(provider[card.id]?.vaultId, function (state) {
            if (state['secret-card-number']?.revealed && state['secret-cvv-number']?.revealed) {
                setShowCardInfo(true);

                dispatch({
                    type: SHOW_CARD_INFO
                });
            }
        });

        fetchCardSecrets(show);
    };
    const fetchCardSecrets = show => {
        const headersToken = {
            'sd-show-token': provider[card.id].token
        };
        const cardNumberIframe = show.request({
            name: 'secret-card-number',
            method: 'GET',
            headers: headersToken,
            path: `/v1/card/${card.id}/show`,
            jsonPathSelector: 'cardNumber',
            serializers: [show.SERIALIZERS.replace('(\\d{4})(\\d{4})(\\d{4})(\\d{4})', '$1 $2 $3 $4')]
        });
        const cvvIframe = show.request({
            name: 'secret-cvv-number',
            method: 'GET',
            headers: headersToken,
            path: `/v1/card/${card.id}/show`,
            jsonPathSelector: 'cvv'
        });
        const copyCardNumberButton = show.copyFrom(
            cardNumberIframe,
            {
                serializers: [show.SERIALIZERS.replace(' ', '')]
            },
            status => {
                if (status === 'success') {
                    SnackBarRef.current.openSnackBar({
                        label: 'Card Number Copied!',
                        severity: 'success'
                    });
                }
            }
        );
        const copyCvvButton = show.copyFrom(cvvIframe, {}, status => {
            if (status === 'success') {
                SnackBarRef.current.openSnackBar({
                    label: 'CVV Copied!',
                    severity: 'success'
                });
            }
        });

        renderCardSecrets(cardNumberIframe, cvvIframe);
        renderCopyButtons({
            copyCardNumberButton,
            copyCvvButton
        });
    };
    const renderCardSecrets = (cardNumber, cvv) => {
        cardNumber.render(cardNumberRef.current, secretCardNumberStyles);
        cvv.render(cvvRef.current, secretsTextStyles);
    };
    const renderCopyButtons = ({ copyCardNumberButton, copyCvvButton }) => {
        copyCardNumberButton.render(cardNumberRef.current, copyButtonStyles);
        copyCvvButton.render(cvvRef.current, copyButtonStyles);
    };

    useEffect(() => {
        if (!card.id) return;
        if (!provider[card.id]?.id) return;
        addVgsScript(showCardSecrets);
    }, [card, provider]);

    useEffect(() => {
        if (deleteFrame) {
            const VgsIframes = document.querySelectorAll('iframe');
            for (const VgsIframe of VgsIframes) {
                VgsIframe.remove();
            }
            setShowCardInfo(false);
            return dispatch({
                type: REMOVE_FRAME
            });
        }
    }, [deleteFrame]);

    const handleCopyCardNumber = async () => {
        const expDate = document.querySelector('.card .exp-date');
        await navigator.clipboard.writeText(expDate.textContent);
        SnackBarRef.current.openSnackBar({
            label: 'Expiration Date Copied!',
            severity: 'success'
        });
    };

    return (
        <Box>
            <Box className="card">
                <Box className="background" style={{ backgroundImage: `url(${Background})` }} />
                <Box className="card-number-container">
                    {checked ? (
                        <Box ref={cardNumberRef} className="card-number" />
                    ) : (
                        <Box className="temporary-number">**** **** **** {card.last4}</Box>
                    )}
                </Box>
                <Box className="card-exp-date-container">
                    <Box className="holders exp-date" marginRight="10px">
                        {checked ? card.expiryMonth + '/' + card.expiryYear.substr(-2) : '** / **'}
                    </Box>
                    {checked && (
                        <img className="copy-btn" src={copyIcon} alt="Copy exp date button" onClick={handleCopyCardNumber} />
                    )}
                </Box>

                <Box className="holders nameHolder">{name}</Box>
                <Box className="placers namePlacer">Paystand, Inc.</Box>

                <Box className="holders cvvHolder">{showCardInfo ? '' : '***'}</Box>
                <Box ref={cvvRef} className="holders cvvHolder"></Box>
            </Box>
            <SnackBarComponent ref={SnackBarRef} />
        </Box>
    );
};

export default PaystandCard;
